// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.movingBanner {
  background-color: #ba1e24;
  padding: 0px 0px 0px 0px;
  /* margin: 100px 0px; */
}
@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-150px * 7));
  }
}

.sliderBanner {
  background: #ba1e24;
  height: 100px;
  margin: auto;
  overflow: hidden;
  position: relative;
  /* width: 960px; */
}

.sliderBanner::before,
.sliderBanner::after {
  content: "";
  height: 100px;
  position: absolute;
  width: 200px;
  z-index: 2;
}

.sliderBanner::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}

.sliderBanner::before {
  left: 0;
  top: 0;
}

.sliderBanner .slide-track {
  animation: scroll 12s linear infinite;
  display: flex;
  width: calc(150px * 14);
}

.sliderBanner .slide {
  height: 100px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.slide > img {
  height: 40px;
  width: 250px;
  object-fit: contain;
}
.showBorderTop {
  border-top: 1px solid white;
}
@media screen and (max-width: 600px) {
  .slick-slide img {
    height: 20px !important;
  }
  .movingBanner {
    padding: 0px 0px;
    margin: 0px 0px;
  }
  .slide > img {
    height: 30px;
  }
  .sliderBanner .slide {
    height: 70px;
    width: 180px;
  }
  .sliderBanner::before,
  .sliderBanner::after {
    content: "";
    height: 70px;
    position: absolute;
    width: 200px;
    z-index: 2;
  }
  .sliderBanner {
    height: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/movingBanner/movingBanner.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":[".movingBanner {\n  background-color: #ba1e24;\n  padding: 0px 0px 0px 0px;\n  /* margin: 100px 0px; */\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(calc(-150px * 7));\n  }\n}\n\n.sliderBanner {\n  background: #ba1e24;\n  height: 100px;\n  margin: auto;\n  overflow: hidden;\n  position: relative;\n  /* width: 960px; */\n}\n\n.sliderBanner::before,\n.sliderBanner::after {\n  content: \"\";\n  height: 100px;\n  position: absolute;\n  width: 200px;\n  z-index: 2;\n}\n\n.sliderBanner::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n\n.sliderBanner::before {\n  left: 0;\n  top: 0;\n}\n\n.sliderBanner .slide-track {\n  animation: scroll 12s linear infinite;\n  display: flex;\n  width: calc(150px * 14);\n}\n\n.sliderBanner .slide {\n  height: 100px;\n  width: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.slide > img {\n  height: 40px;\n  width: 250px;\n  object-fit: contain;\n}\n.showBorderTop {\n  border-top: 1px solid white;\n}\n@media screen and (max-width: 600px) {\n  .slick-slide img {\n    height: 20px !important;\n  }\n  .movingBanner {\n    padding: 0px 0px;\n    margin: 0px 0px;\n  }\n  .slide > img {\n    height: 30px;\n  }\n  .sliderBanner .slide {\n    height: 70px;\n    width: 180px;\n  }\n  .sliderBanner::before,\n  .sliderBanner::after {\n    content: \"\";\n    height: 70px;\n    position: absolute;\n    width: 200px;\n    z-index: 2;\n  }\n  .sliderBanner {\n    height: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
